/*
 * Actividades económicas para EM10/EM11/EM12 del reporte PM/PFAE (Buró Empresas).
 * Fuente: «Catálogo de Equivalencias Código SCIAN – Banxico» (MC-PM-ANEXO-SCIAN V.008, agosto 2025):
 * los códigos SCIAN de 5 dígitos con su descripción (los que tienen y no tienen equivalencia Banxico).
 * El manual v5 acepta Banxico (7 dígitos) o SCIAN, pero EM10, EM11 y EM12 deben ser del mismo tipo.
 * Sin dato: entidades financieras 9999999; empresas comerciales 8888888.
 */
export const SIN_DATO_FINANCIERA = '9999999';
export const SIN_DATO_COMERCIAL = '8888888';

export const ACTIVIDADES = [
  ["11111", "Cultivo de soya"],
  ["11112", "Cultivo de semillas oleaginosas, excepto soya"],
  ["11113", "Cultivo de leguminosas"],
  ["11114", "Cultivo de trigo"],
  ["11115", "Cultivo de maíz"],
  ["11116", "Cultivo de arroz"],
  ["11119", "Cultivo de otros cereales"],
  ["11121", "Cultivo de hortalizas"],
  ["11131", "Cultivo de naranja"],
  ["11132", "Cultivo de otros cítricos"],
  ["11133", "Cultivo de frutales no cítricos y nueces"],
  ["11141", "Cultivo de productos alimenticios en invernaderos"],
  ["11142", "Floricultura, y otros cultivos de productos no alimenticios en invernaderos y viveros"],
  ["11191", "Cultivo de tabaco"],
  ["11192", "Cultivo de algodón"],
  ["11193", "Cultivo de caña de azúcar"],
  ["11194", "Cultivo de alfalfa y pastos"],
  ["11199", "Otros cultivos"],
  ["11211", "Explotación de bovinos para la producción de carne"],
  ["11212", "Explotación de bovinos para la"],
  ["11213", "Explotación de bovinos sin especialización y para otros propósitos"],
  ["11221", "Explotación de porcinos"],
  ["11231", "Explotación de gallinas para la producción de huevo"],
  ["11232", "Explotación de pollos para la producción de carne"],
  ["11233", "Explotación de guajolotes o pavos"],
  ["11234", "Producción de aves en incubadora"],
  ["11239", "Explotación de otras aves para producción de carne y huevo"],
  ["11241", "Explotación de ovinos"],
  ["11242", "Explotación de caprinos"],
  ["11251", "Acuicultura"],
  ["11291", "Apicultura"],
  ["11292", "Explotación de équidos"],
  ["11293", "Cunicultura y explotación de animales con pelaje fino"],
  ["11299", "Explotación de otros animales"],
  ["11311", "Silvicultura"],
  ["11331", "Tala de árboles"],
  ["11411", "Pesca"],
  ["11421", "Caza y captura"],
  ["11511", "Servicios relacionados con la agricultura"],
  ["11531", "Servicios relacionados con el aprovechamiento forestal"],
  ["21111", "Extracción de petróleo y gas"],
  ["21211", "Minería de carbón mineral"],
  ["21221", "Minería de hierro"],
  ["21222", "Minería de oro y plata"],
  ["21223", "Minería de cobre, plomo y zinc"],
  ["21229", "Minería de otros minerales metálicos"],
  ["21232", "Minería de arena, grava, tezontle, tepetate, arcillas y de otros minerales refractarios"],
  ["21239", "Minería de otros minerales no metálicos"],
  ["21311", "Servicios relacionados con la minería"],
  ["22111", "Generación, transmisión y distribución de energía eléctrica"],
  ["22112", "Transmisión y distribución de energía eléctrica"],
  ["22131", "Captación, tratamiento y suministro de agua"],
  ["22221", "Suministro de gas por ductos al consumidor final"],
  ["23611", "Edificación residencial"],
  ["23621", "Edificación de naves y plantas industriales"],
  ["23622", "Edificación de inmuebles comerciales y de servicios"],
  ["23712", "Construcción de obras para petróleo y gas"],
  ["23721", "División de terrenos y construcción de obras de urbanización"],
  ["23731", "Construcción de vías de comunicación"],
  ["23799", "Otras construcciones de ingeniería civil"],
  ["23811", "Trabajos de cimentacionescan., ee.uu."],
  ["23812", "Montaje de estructuras prefabricadascan., ee.uu."],
  ["23813", "Trabajos de albañileríacan., ee.uu."],
  ["23819", "Otros trabajos en exteriorescan., ee.uu."],
  ["23821", "Instalaciones eléctricas en construcciones"],
  ["23831", "Colocación de muros falsos, aislamiento y enyesado"],
  ["23832", "Trabajos de pintura y otros cubrimientos de paredes"],
  ["23833", "Colocación de pisos flexibles y de madera"],
  ["23834", "Colocación de pisos cerámicos y azulejos"],
  ["23839", "Otros trabajos de acabados en edificaciones"],
  ["23891", "Preparación de terrenos para la construcción"],
  ["23899", "Otros trabajos especializados para la construcción"],
  ["31111", "Elaboración de alimentos para animales"],
  ["31121", "Beneficio del arroz, elaboración de productos de molinería, y de malta"],
  ["31122", "Elaboración de almidones, aceites y grasas vegetales comestibles"],
  ["31123", "Elaboración de cereales para el desayuno"],
  ["31131", "Elaboración de azúcares"],
  ["31132", "Elaboración de chocolate y productos de chocolate a partir de cacao"],
  ["31134", "Elaboración de dulces, chicles y productos de confitería que no sean de chocolate"],
  ["31135", "Elaboración de chocolate y productos de chocolate"],
  ["31142", "Conservación de frutas, verduras y alimentos preparados por procesos distintos a la congelación"],
  ["31151", "Elaboración de leche y derivados lácteos"],
  ["31152", "Elaboración de helados y paletas"],
  ["31161", "Matanza, empacado y procesamiento de carne de ganado, aves y otros animales comestibles"],
  ["31171", "Preparación y envasado de pescados y mariscos"],
  ["31181", "Elaboración de pan y otros productos de panadería"],
  ["31182", "Elaboración de galletas y pastas para sopa"],
  ["31183", "Elaboración de tortillas de maíz y molienda de nixtamal"],
  ["31191", "Elaboración de botanas"],
  ["31192", "Industrias del café y del té"],
  ["31193", "Elaboración de concentrados, polvos, jarabes y esencias de sabor para bebidas"],
  ["31194", "Elaboración de condimentos y aderezos"],
  ["31199", "Elaboración de otros alimentos"],
  ["31211", "Elaboración de refrescos, hielo y otras bebidas no alcohólicas, y purificación y embotellado de agua"],
  ["31212", "Elaboración de cerveza"],
  ["31213", "Elaboración de bebidas alcohólicas a base de uva y bebidas fermentadas, excepto cerveza"],
  ["31214", "Elaboración de bebidas destiladas, excepto de uva"],
  ["31221", "Beneficio del tabaco"],
  ["31222", "Elaboración de productos de tabaco"],
  ["31311", "Preparación e hilado de fibras textiles, y fabricación de hilos"],
  ["31321", "Fabricación de telas anchas de trama"],
  ["31323", "Fabricación de telas no tejidas (comprimidas)"],
  ["31324", "Fabricación de telas de punto"],
  ["31331", "Acabado de productos textiles"],
  ["31332", "Fabricación de telas recubiertas"],
  ["31411", "Fabricación de alfombras y tapetes"],
  ["31412", "Confección de cortinas, blancos y similares"],
  ["31491", "Confección de costales y productos de textiles recubiertos y de materiales sucedáneos"],
  ["31499", "Fabricación de otros productos textiles no clasificados en otra parte"],
  ["31511", "Fabricación de calcetines y medias de punto"],
  ["31519", "Fabricación de otras prendas de vestir de punto"],
  ["31522", "Confección de prendas de vestir de materiales textiles"],
  ["31599", "Confección de accesorios de vestir y otras prendas de vestir no clasificados en otra parte."],
  ["31611", "Curtido y acabado de cuero y piel"],
  ["31621", "Fabricación de calzado"],
  ["31699", "Fabricación de otros productos de cuero, piel y materiales sucedáneos"],
  ["32111", "Aserrado y conservación de la madera"],
  ["32121", "Fabricación de laminados y aglutinados de madera"],
  ["32192", "Fabricación de otros productos textiles no clasificados en otra parte"],
  ["32199", "Fabricación de otros productos de cuero, piefabricación de otros productos de madera y de materiales trenzables, excepto palmal y materiales sucedáneos"],
  ["32211", "Fabricación de pulpa"],
  ["32212", "Fabricación de papel"],
  ["32213", "Fabricación de cartón"],
  ["32221", "Fabricación de envases de cartón"],
  ["32222", "Fabricación de bolsas de papel y productos celulósicos recubiertos y tratados"],
  ["32223", "Fabricación de productos de papelería"],
  ["32229", "Fabricación de otros productos de cartón y papel"],
  ["32311", "Impresión"],
  ["32312", "Industrias conexas a la impresión"],
  ["32411", "Refinación de petróleo"],
  ["32412", "Fabricación de productos de asfalto"],
  ["32512", "Fabricación de gases industriales"],
  ["32513", "Fabricación de pigmentos y colorantes sintéticos"],
  ["32521", "Fabricación de resinas y hules sintéticos"],
  ["32522", "Fabricación de fibras químicas"],
  ["32531", "Fabricación de fertilizantes"],
  ["32532", "Fabricación de pesticidas y otros agroquímicos, excepto fertilizantes"],
  ["32541", "Fabricación de productos farmacéuticos"],
  ["32551", "Fabricación de pinturas y recubrimientos"],
  ["32552", "Fabricación de adhesivos"],
  ["32561", "Fabricación de jabones, limpiadores y dentífricos"],
  ["32562", "Fabricación de cosméticos, perfumes y otras preparaciones de tocador"],
  ["32591", "Fabricación de tintas para impresión"],
  ["32592", "Fabricación de explosivos"],
  ["32599", "Fabricación de otros productos químicos"],
  ["32612", "Fabricación de tubería y conexiones, y tubos para embalaje"],
  ["32613", "Fabricación de laminados de plástico rígido"],
  ["32614", "Fabricación de espumas y productos de poliestireno"],
  ["32615", "Fabricación de espumas y productos de uretano"],
  ["32616", "Fabricación de botellas de plástico"],
  ["32619", "Fabricación de otros productos de plástico"],
  ["32621", "Fabricación y revitalización de llantas"],
  ["32629", "Fabricación de otros productos de hule"],
  ["32711", "Fabricación de artículos de alfarería, porcelana, loza y muebles de baño"],
  ["32712", "Fabricación de productos a base de arcilla para la construcción"],
  ["32721", "Fabricación de tubería y conexiones, y tubos para embalaje"],
  ["32731", "Fabricación de cemento y productos a base de cemento en plantas integradas"],
  ["32732", "Fabricación de concreto"],
  ["32733", "Fabricación de tubos y bloques de cemento y concreto"],
  ["32739", "Fabricación de otros productos de cemento y concreto"],
  ["32741", "Fabricación de cal"],
  ["32742", "Fabricación de yeso y productos de yeso"],
  ["32791", "Fabricación de productos abrasivos"],
  ["32799", "Fabricación de otros productos a base de minerales no metálicos"],
  ["33111", "Industria básica del hierro y del acero"],
  ["33122", "Fabricación de otros productos de hierro y acero"],
  ["33131", "Industria básica del aluminio"],
  ["33141", "Fundición y refinación de cobre, metales preciosos y de otros metales no ferrosos"],
  ["33142", "Laminación secundaria de cobre"],
  ["33149", "Laminación secundaria de otros metales no ferrosos"],
  ["33151", "Moldeo por fundición de piezas de hierro y acero"],
  ["33221", "Fabricación de herramientas de mano sin motor y utensilios de cocina metálicos"],
  ["33231", "Fabricación de estructuras metálicas"],
  ["33232", "Fabricación de productos de herrería"],
  ["33241", "Fabricación de calderas industriales"],
  ["33242", "Fabricación de tanques metálicos de calibre grueso"],
  ["33243", "Fabricación de envases metálicos de calibre ligero"],
  ["33251", "Fabricación de herrajes y cerraduras"],
  ["33261", "Fabricación de alambre, productos de alambre y resortes"],
  ["33271", "Maquinado de piezas metálicas para maquinaria y equipo en general"],
  ["33272", "Fabricación de tornillos, tuercas, remaches y similares"],
  ["33281", "Recubrimientos y terminados metálicos"],
  ["33291", "Fabricación de válvulas metálicas"],
  ["33299", "Fabricación de otros productos metálicos"],
  ["33311", "Fabricación de maquinaria y equipo agropecuario"],
  ["33313", "Fabricación de maquinaria y equipo para la industria extractiva"],
  ["33329", "Fabricación de maquinaria y equipo para otras industrias manufactureras"],
  ["33331", "Fabricación de maquinaria y equipo para el comercio y los servicios"],
  ["33341", "Fabricación de equipo de aire acondicionado, calefacción, y de refrigeración industrial y comercial"],
  ["33391", "Fabricación de bombas y sistemas de bombeo"],
  ["33392", "Fabricación de maquinaria y equipo para levantar y trasladar"],
  ["33399", "Fabricación de otra maquinaria y equipo para la industria en general"],
  ["33411", "Fabricación de computadoras y equipo periférico"],
  ["33421", "Fabricación de equipo telefónico"],
  ["33422", "Fabricación de equipo de transmisión y recepción de señales de radio y televisión, y equipo de comunicación inalámbrico"],
  ["33429", "Fabricación de otros equipos de comunicación"],
  ["33431", "Fabricación de equipo de audio y de video"],
  ["33441", "Fabricación de componentes electrónicos"],
  ["33451", "Fabricación de instrumentos de medición, control, navegación, y equipo médico electrónico"],
  ["33511", "Fabricación de focos"],
  ["33512", "Fabricación de lámparas ornamentales"],
  ["33521", "Fabricación de enseres"],
  ["33522", "Fabricación de aparatos de línea blanca"],
  ["33531", "Fabricación de equipo de generación y distribución de energía eléctrica"],
  ["33591", "Fabricación de acumuladores y pilas"],
  ["33592", "Fabricación de cables de conducción eléctrica"],
  ["33593", "Fabricación de enchufes, contactos, fusibles y otros accesorios para instalaciones eléctricas"],
  ["33599", "Fabricación de otros productos eléctricos"],
  ["33611", "Fabricación de automóviles y camionetas"],
  ["33612", "Fabricación de camiones y tractocamiones"],
  ["33621", "Fabricación de carrocerías y remolques"],
  ["33634", "Fabricación de partes de sistemas de frenos para vehículos automotrices"],
  ["33635", "Fabricación de partes de sistemas de transmisión para vehículos automotores"],
  ["33637", "Fabricación de piezas metálicas troqueladas para vehículos automotrices"],
  ["33639", "Fabricación de otras partes para vehículos automotrices"],
  ["33641", "Fabricación de equipo aeroespacial"],
  ["33651", "Fabricación de equipo ferroviario"],
  ["33661", "Fabricación de embarcaciones"],
  ["33699", "Fabricación de otro equipo de transporte"],
  ["33712", "Fabricación de muebles, excepto cocinas integrales, muebles modulares de baño y muebles de oficina y estantería"],
  ["33721", "Fabricación de muebles de oficina y estantería"],
  ["33791", "Fabricación de colchones"],
  ["33792", "Fabricación de persianas y cortineros"],
  ["33911", "Fabricación de equipo no electrónico y material desechable de uso médico, dental y para laboratorio, y artículos oftálmicos"],
  ["33991", "Metalistería y joyería"],
  ["33992", "Fabricación de artículos deportivos"],
  ["33993", "Fabricación de juguetes"],
  ["33994", "Fabricación de artículos y accesorios para escritura, pintura, dibujo y actividades de oficina"],
  ["33995", "Fabricación de anuncios y señalamientos"],
  ["33999", "Otras industrias manufactureras"],
  ["43111", "Comercio al por mayor de abarrotes"],
  ["43112", "Comercio al por mayor de carnes"],
  ["43113", "Comercio al por mayor de frutas y verduras frescas"],
  ["43114", "Comercio al por mayor de huevo"],
  ["43115", "Come8219075rcio al por mayor de semillas y granos alimenticios, especias ychiles secos"],
  ["43116", "Comercio al por mayor de leche y otros productos lácteos"],
  ["43117", "Comercio al por mayor de embutidos"],
  ["43118", "Comercio al por mayor de dulces y materias"],
  ["43119", "Comercio al por mayor de otros alimentos"],
  ["43121", "Comercio al por mayor de bebidas y hielo"],
  ["43122", "Comercio al por mayor de cigarros, puros y tabaco"],
  ["43211", "Comercio al por mayor de productos textiles, excepto ropa"],
  ["43212", "Comercio al por mayor de ropa, bisutería y accesorios de vestir"],
  ["43213", "Comercio al por mayor de calzado"],
  ["43311", "Comercio al por mayor de productos farmacéuticos"],
  ["43321", "Comercio al por mayor de artículos de perfumería y cosméticos"],
  ["43322", "Comercio al por mayor de artículos de joyería y relojes"],
  ["43331", "Comercio al por mayor de discos, juguetes y artículos deportivos"],
  ["43341", "Comercio al por mayor de artículos de papelería"],
  ["43342", "Comercio al por mayor de libros"],
  ["43343", "Comercio al por mayor de revistas y periódicos"],
  ["43411", "Comercio al por mayor de materias primas agropecuarias y forestales"],
  ["43422", "Comercio al por mayor de otros materiales para la construcción y materias primas para otras industrias"],
  ["43424", "Comercio al por mayor de artículos desechables"],
  ["43431", "Comercio al por mayor de materiales de desecho"],
  ["43511", "Comercio al por mayor de maquinaria y equipo agropecuario, forestal y para la pesca"],
  ["43521", "Comercio al por mayor de maquinaria y equipo para la construcción y la minería"],
  ["43531", "Comercio al por mayor de maquinaria y equipo para los servicios y para actividades comerciales"],
  ["43541", "Comercio al por mayor de mobiliario y equipo de cómputo y de oficina, y de otra maquinaria y equipo de uso general"],
  ["43711", "Intermediación de comercio al por mayor, excepto a través de internet y de otros medios electrónicos"],
  ["46112", "Comercio al por menor de carnes"],
  ["46114", "Comercio al por menor de semillas y granos alimenticios, especias y chiles secos"],
  ["46119", "Comercio al por menor de otros alimentos"],
  ["46121", "Comercio al por menor de bebidas y hielo"],
  ["46211", "Comercio al por menor en tiendas de autoservicio"],
  ["46311", "Comercio al por menor de productos textiles, excepto ropa"],
  ["46321", "Comercio al por menor de ropa, bisutería y accesorios de vestir"],
  ["46331", "Comercio al por menor de calzado"],
  ["46412", "Comercio al por menor de lentes y artículos ortopédicos"],
  ["46521", "Comercio al por menor de artículos para el esparcimiento"],
  ["46591", "Comercio al por menor de mascotas, regalos, artículos religiosos, desechables y otros artículos de uso personal"],
  ["46611", "Comercio al por menor de muebles para el hogar y otros enseres domésticos"],
  ["46631", "Comercio al por menor de artículos para la decoración de interiores"],
  ["46641", "Comercio al por menor de artículos usados"],
  ["46711", "Comercio al por menor de artículos de ferretería, tlapalería y vidrios"],
  ["46811", "Comercio al por menor de automóviles y camionetas"],
  ["46821", "Comercio al por menor de partes y refacciones para automóviles, camionetas y camiones"],
  ["46831", "Comercio al por menor de motocicletas y otros vehículos de motor"],
  ["46841", "Comercio al por menor de combustibles"],
  ["46842", "Comercio al por menor de aceites y grasas lubricantes, aditivos y similares para vehículos de motor"],
  ["48111", "Transporte aéreo regular"],
  ["48121", "Transporte aéreo no regular"],
  ["48211", "Transporte por ferrocarril"],
  ["48311", "Transporte marítimo"],
  ["48321", "Transporte por aguas interiores"],
  ["48411", "Autotransporte local de carga general"],
  ["48412", "Autotransporte foráneo de carga general"],
  ["48421", "Servicios de mudanzas"],
  ["48422", "Autotransporte local de carga especializado, excepto mudanzas"],
  ["48423", "Autotransporte foráneo de carga especializado, excepto mudanzas"],
  ["48511", "Transporte colectivo urbano y suburbano de pasajeros de ruta fija"],
  ["48521", "Transporte colectivo foráneo de pasajeros de ruta fija"],
  ["48531", "Servicio de taxis"],
  ["48532", "Alquiler de automóviles con chofer"],
  ["48541", "Transporte escolar y de"],
  ["48551", "Alquiler de autobuses con chofer"],
  ["48599", "Otro transporte terrestre de pasajeros"],
  ["48611", "Transporte de petróleo crudo por ductos"],
  ["48621", "Transporte de gas natural por ductos"],
  ["48711", "Transporte turístico por tierra"],
  ["48721", "Transporte turístico por agua"],
  ["48799", "Otro transporte turístico"],
  ["48811", "Operaciones aeroportuarias"],
  ["48819", "Otros servicios relacionados con el transporte aéreo"],
  ["48831", "Administración de puertos y muelles"],
  ["48832", "Servicios de carga y descarga para el transporte por agua"],
  ["48833", "Servicios para la navegación por agua"],
  ["48841", "Servicios de grúa"],
  ["48849", "Otros servicios relacionados con el transporte por carretera"],
  ["48851", "Servicios de intermediación para"],
  ["48899", "Otros servicios relacionados con el transporte"],
  ["49111", "Servicios postales"],
  ["49211", "Servicios de mensajería y paquetería foránea"],
  ["49221", "Servicios de mensajería y paquetería local"],
  ["49311", "Almacenes generales de depósito y otros servicios de almacenamiento general sin instalaciones especializadas"],
  ["49312", "Almacenamiento con refrigeración"],
  ["51211", "Producción de películas, programas para la televisión y otros materiales audiovisuales"],
  ["51212", "Distribución de películas y de otros materiales audiovisuales"],
  ["51213", "Exhibición de películas y otros materiales audiovisuales"],
  ["51219", "Servicios de postproducción y otros servicios para la industria fílmica y del video"],
  ["51221", "Productoras discográficas"],
  ["51223", "Editoras de música"],
  ["51225", "Productoras y distribuidoras discográficas"],
  ["51229", "Otros servicios de grabación del sonido"],
  ["51511", "Transmisión de programas de radio"],
  ["51512", "Transmisión de programas de televisión"],
  ["51711", "Operadores de telecomunicaciones alámbricas"],
  ["51741", "Servicios de telecomunicaciones por satélite"],
  ["51791", "Otros servicios de 91 telecomunicaciones"],
  ["51911", "Agencias noticiosas"],
  ["51912", "Bibliotecas y archivos"],
  ["51919", "Otros servicios de suministro de información"],
  ["52111", "Banca central"],
  ["52211", "Banca múltiple"],
  ["52221", "Banca de desarrollo"],
  ["52222", "Fondos y fideicomisos financieros"],
  ["52231", "Uniones de crédito"],
  ["52232", "Cajas de ahorro popular"],
  ["52239", "Otras instituciones de ahorro y préstamo"],
  ["52241", "Arrendadoras financieras"],
  ["52243", "Sociedades financieras de objeto limitado"],
  ["52244", "Compañías de autofinanciamiento"],
  ["52245", "Montepíos y casas de empeño"],
  ["52246", "Sociedades financieras de objeto múltiple"],
  ["52249", "Otras instituciones de intermediación crediticia y financiera no bursátil"],
  ["52251", "Servicios relacionados con 51 la intermediación crediticia no bursátil"],
  ["52311", "Casas de bolsa"],
  ["52312", "Casas de cambio y 12 centros cambiarios"],
  ["52321", "Bolsa de valores"],
  ["52391", "Asesoría en inversiones"],
  ["52411", "Compañías de seguros"],
  ["52412", "Fondos de aseguramiento campesino"],
  ["52413", "Compañías afianzadoras"],
  ["52421", "Agentes, ajustadores y gestores de seguros y fianzas"],
  ["52521", "Fondos de inversión"],
  ["53111", "Alquiler sin intermediación de bienes raíces"],
  ["53121", "Inmobiliarias y corredores de bienes raíces"],
  ["53131", "Servicios relacionados con los servicios inmobiliarios"],
  ["53211", "Alquiler de automóviles sin chofer"],
  ["53221", "Alquiler de aparatos eléctricos y electrónicos para el hogar y personales"],
  ["53223", "Alquiler de videocasetes y discos"],
  ["53228", "Alquiler de otros artículos para el hogar y personales"],
  ["53231", "Centros generales de alquiler"],
  ["53241", "Alquiler de maquinaria y equipo para construcción, minería, actividades forestales y transporte, excepto terrestre"],
  ["53242", "Alquiler de equipo de cómputo y de otras máquinas y mobiliario de oficina"],
  ["54111", "Bufetes jurídicos"],
  ["54112", "Notarías públicas"],
  ["54119", "Servicios de apoyo para efectuar trámites legales"],
  ["54121", "Servicios de contabilidad, auditoría y servicios relacionados"],
  ["54131", "Servicios de arquitectura"],
  ["54132", "Servicios de arquitectura de paisaje y urbanismo"],
  ["54133", "Servicios de ingeniería"],
  ["54134", "Servicios de dibujo"],
  ["54135", "Servicios de inspección de edificios"],
  ["54136", "Servicios de levantamiento geofísico"],
  ["54137", "Servicios de elaboración de mapas"],
  ["54138", "Laboratorios de pruebas"],
  ["54141", "Diseño y decoración de interiores"],
  ["54142", "Diseño industrial"],
  ["54143", "Diseño gráfico"],
  ["54149", "Diseño de modas y otros diseños especializados"],
  ["54161", "Servicios de consultoría en administración"],
  ["54162", "Servicios de consultoría en medio ambiente"],
  ["54169", "Otros servicios de consultoría científica y técnica"],
  ["54171", "Servicios de investigación científica y desarrollo en ciencias naturales y exactas, ingeniería, y"],
  ["54181", "Agencias de publicidad"],
  ["54182", "Agencias de relaciones públicas"],
  ["54183", "Agencias de compra de medios a petición del cliente"],
  ["54184", "Agencias de representación de medios"],
  ["54185", "Agencias de anuncios publicitarios"],
  ["54186", "Agencias de correo directo"],
  ["54187", "Distribución de material publicitario"],
  ["54191", "Servicios de investigación de mercados y encuestas de opinión pública"],
  ["54192", "Servicios de fotografía y videograbación"],
  ["54193", "Servicios de traducción e interpretación"],
  ["54194", "Servicios veterinarios"],
  ["54199", "Otros servicios profesionales, científicos y técnicos"],
  ["55111", "11 corporativos"],
  ["56111", "Servicios de administración de negocios"],
  ["56121", "Servicios combinados de apoyo en instalaciones"],
  ["56131", "Agencias de colocación"],
  ["56132", "Agencias de empleo temporal"],
  ["56133", "Suministro de personal permanente"],
  ["56141", "Servicios de preparación de documentos"],
  ["56143", "Servicios de fotocopiado, fax, acceso a computadoras y afines"],
  ["56144", "Agencias de cobranza"],
  ["56145", "Despachos de investigación de solvencia financiera"],
  ["56149", "Otros servicios de apoyo secretarial y similares"],
  ["56151", "Agencias de viajes"],
  ["56159", "Otros servicios de reservaciones"],
  ["56162", "Servicios de protección y custodia mediante 62 el monitoreo de sistemas de seguridad"],
  ["56171", "Servicios de control y exterminación de plagas"],
  ["56172", "Servicios de limpieza de inmuebles"],
  ["56179", "Otros servicios de limpieza"],
  ["56191", "Servicios de empacado y etiquetado"],
  ["56199", "Otros servicios de apoyo a los negocios"],
  ["56291", "Servicios de remediación"],
  ["56292", "Recuperación de residuos"],
  ["56299", "Otros servicios de manejo de residuos"],
  ["61111", "Escuelas de educación preescolar"],
  ["61112", "Escuelas de educación primaria"],
  ["61113", "Escuelas de educación secundaria general"],
  ["61114", "Escuelas de educación secundaria técnica"],
  ["61115", "Escuelas de educación media técnica terminal"],
  ["61116", "Escuelas de educación media superior"],
  ["61121", "Escuelas de educación postbachillerato"],
  ["61131", "Escuelas de educación superior"],
  ["61141", "Escuelas comerciales y secretariales"],
  ["61142", "Escuelas de computación"],
  ["61143", "Escuelas para la capacitación de ejecutivos"],
  ["61151", "Escuelas de oficios"],
  ["61161", "Escuelas de arte"],
  ["61162", "Escuelas de deporte"],
  ["61163", "Escuelas de idiomas"],
  ["61169", "Otros servicios educativos"],
  ["61171", "Servicios de apoyo a la educación"],
  ["62111", "Consultorios médicos"],
  ["62121", "Consultorios dentales"],
  ["62131", "Consultorios de quiropráctica"],
  ["62132", "Consultorios de optometría"],
  ["62133", "Consultorios de psicología"],
  ["62139", "Otros consultorios para el cuidado de la salud"],
  ["62141", "Centros de planificación familiar"],
  ["62151", "Laboratorios médicos y de diagnóstico del sector privado"],
  ["62161", "Servicios de enfermería a domicilio"],
  ["62191", "Servicios de ambulancias"],
  ["62199", "Servicios de bancos de órganos, bancos de sangre y otros servicios auxiliares al tratamiento médico"],
  ["62211", "Hospitales generales"],
  ["62231", "Hospitales de otras especialidades médicas"],
  ["62399", "Orfanatos y otras residencias de asistencia social"],
  ["62419", "Otros servicios de orientación y trabajo social"],
  ["62421", "Servicios de alimentación comunitarios"],
  ["62422", "Refugios temporales comunitarios"],
  ["62423", "Servicios de emergencia comunitarios"],
  ["62441", "Guarderías"],
  ["71111", "Compañías de teatro"],
  ["71112", "Compañías de danza"],
  ["71113", "Cantantes y grupos musicales"],
  ["71121", "Deportistas y equipos deportivos profesionales"],
  ["71131", "Promotores de espectáculos artísticos, culturales, deportivos y similares que cuentan con instalaciones para presentarlos"],
  ["71141", "Agentes y representantes de artistas, deportistas y similares"],
  ["71151", "Artistas, escritores y técnicos independientes"],
  ["71211", "Museos"],
  ["71212", "Sitios históricos"],
  ["71213", "Jardines botánicos y zoológicos"],
  ["71311", "Parques con instalaciones recreativas"],
  ["71312", "Casas de juegos electrónicos"],
  ["71321", "Casinos"],
  ["71329", "Loterías y otros juegos de azar"],
  ["71391", "Campos de golf"],
  ["71392", "Pistas para esquiar"],
  ["71393", "Marinas turísticas"],
  ["71394", "Clubes deportivos y centros de acondicionamiento físico"],
  ["71395", "Boliches"],
  ["71399", "Otros servicios 99 recreativos"],
  ["72111", "Hoteles y moteles, excepto hoteles con casino"],
  ["72112", "Hoteles con casino"],
  ["72119", "Cabañas, villas y similares"],
  ["72121", "Campamentos y albergues recreativos"],
  ["72131", "Pensiones y casas de huéspedes, y departamentos y casas amueblados con servicios de hotelería"],
  ["72211", "Restaurantes con servicio completo"],
  ["72221", "Restaurantes de autoservicio, comida para llevar y otros restaurantes con servicio limitado"],
  ["72231", "Servicios de comedor para empresas e instituciones"],
  ["72241", "Centros nocturnos, bares, cantinas y similares"],
  ["81111", "Reparación mecánica y eléctrica de automóviles y camiones"],
  ["81112", "Hojalatería, tapicería y otras reparaciones a la carrocería de automóviles y camiones"],
  ["81119", "Otros servicios de reparación y mantenimiento de automóviles y camiones"],
  ["81121", "Reparación y mantenimiento de equipo electrónico y de equipo de precisión"],
  ["81131", "Reparación y mantenimiento de maquinaria y equipo agropecuario, industrial, comercial y de servicios"],
  ["81141", "Reparación y mantenimiento de aparatos eléctricos para el hogar y personales"],
  ["81142", "Reparación de tapicería de muebles para el hogar"],
  ["81143", "Reparación de calzado y otros artículos de piel y cuero"],
  ["81149", "Reparación y mantenimiento de otros artículos para el hogar y personales"],
  ["81211", "Salones y clínicas de belleza y peluquerías"],
  ["81212", "Baños públicos"],
  ["81213", "Sanitarios públicos y bolerías"],
  ["81221", "Lavanderías y tintorerías"],
  ["81231", "Servicios funerarios"],
  ["81232", "Administración de cementerios"],
  ["81241", "Estacionamientos y pensiones para vehículos automotorescan., ee.uu."],
  ["81291", "Servicios de revelado e impresión de fotografías"],
  ["81299", "Otros servicios personales"],
  ["81311", "Asociaciones, organizaciones y cámaras de productores, comerciantes y prestadores de servicios"],
  ["81312", "Asociaciones y organizaciones laborales y sindicales"],
  ["81313", "Asociaciones y organizaciones de profesionistas"],
  ["81321", "Asociaciones y organizaciones religiosas"],
  ["81322", "Asociaciones y organizaciones políticas"],
  ["81323", "Asociaciones y organizaciones civiles"],
  ["81411", "Hogares con empleados domésticos"],
  ["93111", "Órganos legislativos"],
  ["93121", "Administración pública en general"],
  ["93131", "Regulación y fomento del desarrollo económico"],
  ["93171", "Relaciones exteriores"],
  ["93181", "Actividades de seguridad nacional"],
  ["93211", "Organismos internacionales"],
  ["93212", "Sedes diplomáticas y otras unidades extraterritoriales"],
];

const POR_CODIGO = new Map(ACTIVIDADES);

// Quita ceros a la izquierda (el campo es N de 11) para comparar contra el catálogo.
const sinCeros = (v) => String(v ?? '').trim().replace(/^0+(?=\d)/, '');

// Descripción de una actividad ya capturada. null si el código no está en el catálogo SCIAN
// (puede ser una clave Banxico de 7 dígitos) o si está vacío.
export const describirActividad = (valor) => {
  const v = sinCeros(valor);
  if (v === '') return null;
  if (v === SIN_DATO_FINANCIERA) return 'Sin dato (entidad financiera)';
  if (v === SIN_DATO_COMERCIAL) return 'Sin dato (empresa comercial)';
  return POR_CODIGO.get(v) || null;
};
